<template>
  <div class="fill-height">
    <template v-if="isFetched">
      <the-map ref="map" />
      <the-sidebar />
    </template>
    <template v-else>
      <v-row no-gutters class="fill-height" align="center">
        <v-col cols="12">
          <v-row no-gutters justify="center">
            <v-col cols="auto">
              <img :src="require('@/assets/images/logo-loader.svg')" width="100px" />
            </v-col>
          </v-row>
          <v-row no-gutters justify="center" align="center">
            <v-col cols="auto" class="pr-5"> <main-loader size="40" /> </v-col>
            <v-col cols="auto" class="text-body-2"> {{ $i18n.t('sidebar.waitForOffersLoading') }} </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </div>
</template>
<script>
import { call, get } from 'vuex-pathify';
import TheMap from '@/components/map/TheMap';
import TheSidebar from '@/components/sidebar/TheSidebar';
import MainLoader from '@/components/shared/MainLoader.vue';

export default {
  name: 'MainWebView',
  components: { TheMap, TheSidebar, MainLoader },
  computed: {
    settingsValues: get('admin/settings'),
  },
  data: () => ({
    isFetched: false,
  }),
  methods: {
    getDataSources: call('featuresData/getDataSources'),
    getLayers: call('featuresData/getLayers'),
    getProjects: call('featuresData/getProjects'),
    getOffersTree: call('featuresData/getOffersTree'),
    async fetchInitData() {
      this.isFetched = false;
      const languagesProjectsIds = this.$_config.languages.reduce((total, current) => {
        total[current] = this.settingsValues['PROJECTS_LEGEND_SETTING']?.value[current];
        return total;
      }, {});
      const offersLayersIds = this.$_config.languages.reduce((total, lng) => {
        const lngLayers = ['BROWNFIELDS_LAYERS_SETTING', 'GREENFIELDS_LAYERS_SETTING', 'INVESTED_LAYERS_SETTING'].map(
          setting => {
            return this.settingsValues[setting]?.value?.layers?.[lng];
          }
        );
        return [...total, ...lngLayers];
      }, []);
      const offersCartogramLayersIds = ['COMMUNE_SETTING', 'DISTRICT_SETTING', 'VOIVODESHIP_SETTING']
        .map(setting => {
          return this.settingsValues[setting]?.value?.layer;
        })
        .filter(layerId => !!layerId || layerId === 0);
      await Promise.all([
        this.getProjects(languagesProjectsIds),
        this.getLayers(),
        this.getDataSources(),
        this.getOffersTree({ layersIds: [...offersCartogramLayersIds, ...offersLayersIds] }),
      ]);
      this.isFetched = true;
    },
  },
  mounted() {
    this.fetchInitData();
  },
};
</script>
